import React, { Fragment } from "react";
import { Link } from "react-router-dom";
const ProductCard = ({ LoadData, data }) => {
  return (
    <Fragment>
      <div className="card h-100">
        <Link to="">
          <img
            src="/images/company2.jpg"
            className="card-img-top rounded"
            alt="..."
            onClick={(event) => LoadData(event, data.id)}
          />
        </Link>

        <div className="align-items-stretch card-body d-flex flex-column justify-content-between">
          <h6 className="card-title">
            <Link to="" className="text-dark fw-bold">
              {data.title}
            </Link>
          </h6>
          <hr />
          <div className="d-flex justify-content-between  text-muted">
            <button
              onClick={(event) => LoadData(event, data.id)}
              className="btn btn-outline-primary w-100"
            >
              مشاهده ...
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductCard;
